import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import DetailsSection from '../DetailsSection';
import { formValidators, getErrorMessage } from '../../../../helpers/formErrorMessages';
import { privacyAndTermsState } from '../helper';
import { getIconColour } from '../../../../helpers/app';
import TooltipInput from '../../../../components/Input/TooltipInput';
import { TOOLTIPS } from '../../../../constants/tooltips';
import FingerPrintIcon from '../../../../assets/icons/FingerPrint';
import { ExpandContent, GridRow } from '../styles';
import { ApplicationInterface } from '../../../../interfaces/application';

type PropsType = {
  formHook: UseFormReturn<ApplicationInterface>;
  expand?: boolean;
  onClick: () => void;
};

const ExpandedPrivacyAndTerms: React.FC<{ formHook: UseFormReturn<ApplicationInterface> }> = ({
  formHook,
}) => {
  const {
    register,
    formState: { errors },
  } = formHook;

  return (
    <ExpandContent>
      <GridRow>
        <TooltipInput
          tooltipText={TOOLTIPS.privacyPolicy}
          inputProps={register('info.privacyUrl', { validate: formValidators.website })}
          id="privacyPolicyLink"
          label="Link to Privacy Policy"
          variant="outlined"
          autoComplete="off"
          error={!!errors.info?.privacyUrl}
          helperText={getErrorMessage(errors.info?.privacyUrl)}
          focused={false}
          card
        />

        <TooltipInput
          tooltipText={TOOLTIPS.termsOfUse}
          inputProps={register('info.termsUrl', { validate: formValidators.website })}
          id="termsLink"
          label="Link to Terms of Use"
          variant="outlined"
          autoComplete="off"
          error={!!errors.info?.termsUrl}
          helperText={getErrorMessage(errors.info?.termsUrl)}
          focused={false}
          card
        />
      </GridRow>

      <Typography>
        These links are for the end-user and will be publicly displayed and linked from your
        application’s detail page.
      </Typography>
    </ExpandContent>
  );
};

const PrivacyAndTerms: React.FC<PropsType> = ({ formHook, expand, onClick }) => {
  const type = privacyAndTermsState(formHook);
  const theme = useTheme();

  return (
    <DetailsSection
      icon={<FingerPrintIcon stroke={getIconColour(type, theme)} />}
      title="Privacy & Terms of Use"
      description="Privacy Policy and Terms of Use documents."
      expand={expand}
      onClick={onClick}
      type={type}
    >
      <ExpandedPrivacyAndTerms formHook={formHook} />
    </DetailsSection>
  );
};

export default PrivacyAndTerms;
